import { Column } from 'react-table';
import { Box, styled, Tooltip, Typography } from '@mui/material';
import { IconCertificate } from 'assets/img';
import { ContextMenuButton } from 'redesign';
import { TFunctionNonStrict } from 'i18next';
import {
  PartnerPlannerTableCellProp,
  PartnerPlannerTableDefinition,
} from './partner-planner-modal-table.types';

export const getPlannerModalTableDefinition: (
  t: TFunctionNonStrict<'hq-screen-specific', undefined>
) => Column<PartnerPlannerTableDefinition>[] = (t) => {
  const name: Column<PartnerPlannerTableDefinition> = {
    Header: t('shifts.candidates.table_headers.name', { ns: 'hq-screen-specific' }),
    accessor: 'worker',
    Cell: WorkerCell,
    width: '200px',
  };
  const email: Column<PartnerPlannerTableDefinition> = {
    Header: t('shifts.candidates.table_headers.email', { ns: 'hq-screen-specific' }),
    accessor: 'email',
    Cell: EmailCell,
  };
  const phone: Column<PartnerPlannerTableDefinition> = {
    Header: t('shifts.candidates.table_headers.phone', { ns: 'hq-screen-specific' }),
    accessor: 'phone',
    Cell: PhoneCell,
    width: '150px',
  };
  const certificate: Column<PartnerPlannerTableDefinition> = {
    Header: '',
    accessor: 'hasRequiredCertificates',
    Cell: CertificateCell,
    width: '24px',
  };
  const actions: Column<PartnerPlannerTableDefinition> = {
    Header: '',
    accessor: 'actions',
    Cell: ActionCell,
    width: '50px',
  };

  return [name, email, phone, certificate, actions];
};

const WorkerCell = (cell: PartnerPlannerTableCellProp<'worker'>) => {
  return (
    <Box>
      <Typography variant="subtitle2">{cell.value.name}</Typography>
      <Tooltip title={cell.value.partnerName}>
        <LabelBox>{cell.value.partnerName}</LabelBox>
      </Tooltip>
    </Box>
  );
};

const EmailCell = (cell: PartnerPlannerTableCellProp<'email'>) => {
  return <Typography variant="subtitle2">{cell.value}</Typography>;
};

const PhoneCell = (cell: PartnerPlannerTableCellProp<'phone'>) => {
  return <Typography variant="subtitle2">{cell.value}</Typography>;
};

const CertificateCell = (cell: PartnerPlannerTableCellProp<'hasRequiredCertificates'>) => {
  return cell.value ? (
    <Tooltip
      title="Deze flexwerker is in het bezit van alle benodigde certificaten"
      aria-label="certificate-check"
    >
      <Box>
        <IconCertificate width={24} />
      </Box>
    </Tooltip>
  ) : null;
};

const ActionCell = (cell: PartnerPlannerTableCellProp<'actions'>) => {
  const actions = cell.getRowActions({
    workerId: cell.value.workerId,
    shiftClaimId: cell.value.shiftClaimId,
  });

  if (actions.length === 0) {
    return null;
  }

  return (
    <ContextMenuButton menuId={`claimant-actions-menu-${cell.value.workerId}`}>
      {actions}
    </ContextMenuButton>
  );
};

const LabelBox = styled(Box)(() => ({
  border: '1px solid #eeeeee',
  borderRadius: '16px',
  backgroundColor: 'white',
  padding: '0 8px',
  lineHeight: '12px',
  fontSize: '10px',
  textAlign: 'center',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  width: 'fit-content',
}));
